import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, EditIcon, Text } from '@mercai/clever'
import { CustomAccordion } from '@/components'

import { ProfileConsumptionProps } from './consumption.type'

import styles from './consumption.module.css'

import { checkIfConsumptionIsComplete } from '../../general.constants'

export const ProfileConsumption = ({
  lead,
  onClickEdit,
}: ProfileConsumptionProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenProfileShow')

  const [activeItems, setActiveItems] = useState(['consumption'])

  const isComplete = checkIfConsumptionIsComplete(lead)

  return (
    <div className={styles.core}>
      <CustomAccordion
        activeItems={activeItems}
        setActiveItems={setActiveItems}
        id="consumption"
        title={`6. ${t('generalViewGeneralInformationConsumptionTitle')}`}
        isComplete={isComplete}
      >
        <div className={styles['info-block']}>
          <div className={styles['info-row']}>
            <div className={styles['info-row-content']}>
              <Text className={styles['info-item']}>
                <strong>
                  {t('generalViewProductsIndustryConsumptionMonthlyLabel')}:
                </strong>{' '}
                {lead?.monthlyBuyingPotential || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>
                  {t('generalViewProductsIndustryFrequencyLabel')}:
                </strong>{' '}
                {lead?.purchaseFrequency
                  ? tEnums(`lead_frequency_${lead.purchaseFrequency}`)
                  : '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewProductsIndustryAgeLabel')}:</strong>{' '}
                {lead?.companyAge
                  ? `${lead.companyAge} ${t('consumptionFormAgeSufixLabel')}`
                  : '-'}
              </Text>
            </div>

            <Button
              variant="secondary"
              className={styles.edit}
              size="small"
              onClick={onClickEdit}
            >
              <EditIcon />
            </Button>
          </div>
        </div>
      </CustomAccordion>
    </div>
  )
}
